export default __webpack_public_path__ + "static/updownbig-38178731747795ccdc6e25ef9cb82ea4.png";